<nz-page-header
  [nzTitle]="'Communication Configurations' | locale"
  [nzBackIcon]="null"
  (nzBack)="(false)"
>
  <nz-page-header-extra>
    <input
      class="search-input"
      nz-input
      [placeholder]="'Search for employee' | locale"
      [(ngModel)]="searchExp"
      (ngModelChange)="searchForEmp($event)"
    /> </nz-page-header-extra
></nz-page-header>
<div class="emails-config-table">
  <nz-table
    [nzData]="employees"
    [nzBordered]="true"
    class="emails-config-table"
    nzShowQuickJumper="true"
    nzSize="small"
    [nzFrontPagination]="false"
  >
    <thead>
      <th locale>Name</th>
      <th locale>Communication setting</th>
      <th style="width: 50px"></th>
    </thead>
    <tbody>
      <tr *ngFor="let emp of employees">
        <td>{{ emp.U_NAME }} ({{ emp.USER_CODE }})</td>
        <td>{{ emp.EmailFromId | EmailFrom : emailFroms }}</td>
        <td>
          <button
            nz-button
            (click)="showEmailFromsModal(emp.KEY)"
            nzType="primary"
            locale
            style="border-radius: 5px"
          >
            Change
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>

<nz-modal
  [(nzVisible)]="showEmailsFrom"
  [nzTitle]="'Choose an Email from' | locale"
  nzWidth="50%"
  [nzFooter]="null"
  [nzClosable]="true"
>
  <nz-table
    #basicTable
    [nzData]="emailFroms"
    [nzShowPagination]="false"
    [nzFrontPagination]="false"
  >
    <thead>
      <tr>
        <th locale>Display Name</th>
        <th locale>Email</th>
        <th locale>Host</th>
        <th locale>Protocol</th>
        <th locale>User Name</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let data of basicTable.data"
        (click)="onChooseRecord(data.id)"
      >
        <td>{{ data.displayName }}</td>
        <td>{{ data.email }}</td>
        <td>{{ data.sender.host }}</td>
        <td>{{ data.sender.protocol }}</td>
        <td>{{ data.sender.userName }}</td>
      </tr>
    </tbody>
  </nz-table>
</nz-modal>
